export default __webpack_public_path__ + "static/media/time-line-bottom.46db3697.svg";